import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';

import { ReviewIcon } from '../../../icons';
import { ProfileGenericButton } from '../../../molecules/ProfileGenericButton';

import { useDriverFeedbackContext } from './DriverFeedbackProvider';

interface IDriverFeedbackGenericButtonProps {
	onReviewsClick: VoidFunction;
}

export const DriverFeedbackGenericButton: FC<
	IDriverFeedbackGenericButtonProps
> = ({ onReviewsClick }) => {
	const { t } = useTranslation('profile');
	const { averageRating, isLoading } = useDriverFeedbackContext();

	return (
		<ProfileGenericButton
			testId="initialScreen-reviewsButton"
			onClick={onReviewsClick}
			mainIcon={
				isLoading ? (
					<CircularProgress sx={{ maxHeight: 24, maxWidth: 24 }} />
				) : (
					<ReviewIcon />
				)
			}
			label={t('feedback.all_reviews')}
			helperText={averageRating > 0 ? String(averageRating) : '-'}
			variant="white"
		/>
	);
};
